import Disputes from '../features/disputes';

export const DisputesPage = () => <Disputes />;
